export function ZodInit(defaultInitFn) {
    const init = {
        id: 'ZodInit',
        value: (Schema) => ({
            init: {
                value(...args) {
                    return this._def.initFn ? this._def.initFn() : defaultInitFn(this, ...args);
                }
            },
            initFn: {
                value(init) {
                    return new Schema({
                        ...this._def,
                        initFn: init
                    });
                }
            }
        })
    };
    return init;
}
